import React, { useState } from "react";
import { Button, Box, Spacer, Table, Flex, Icon } from "orcs-design-system";
import { useQuery } from "@apollo/client";
import FancyCard, { FancyCardBody } from "src/components/FancyCard/FancyCard";
import { getApiKeys } from "src/queries/apiKeys.graphql";
import columnConfig from "./columnConfig";
import CreateModal from "./createModal";
import SecretRevealModal from "./secretRevealModal";
import RotateSecretModal from "./rotateSecretModal";
import DeleteSecretModal from "./deleteSecretModal";

const APIKeyManager = () => {
  const columns = columnConfig();
  const { data, refetch } = useQuery(getApiKeys);
  const [rotateSecretVisible, setRotateSecretVisible] = useState(false);
  const [deleteSecretVisible, setDeleteSecretVisible] = useState(false);
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [clientId, setClientId] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [secretVisible, setSecretVisible] = useState(false);

  let apiKeys = data?.apiKeys || [];
  apiKeys = apiKeys.map((key) => ({
    ...key,
    clientMetadata: {
      ...key.clientMetadata,
      workspaces: key.clientMetadata.workspaces.join(", "),
      readScopes: key.clientMetadata.readScopes.join(", "),
      writeScopes: key.clientMetadata.writeScopes.join(", "),
      expiryDate: key.clientMetadata.expiryDate,
    },
    actions: (
      <Box>
        <Flex>
          <Spacer mr="s">
            <Button
              small
              onClick={() => {
                setRotateSecretVisible(true);
                setClientId(key.clientId);
              }}
            >
              Rotate secret
            </Button>
            <Button
              small
              onClick={() => {
                setDeleteSecretVisible(true);
                setClientId(key.clientId);
              }}
            >
              Delete
            </Button>
          </Spacer>
        </Flex>
      </Box>
    ),
  }));

  const handleOnButtonClick = () => {
    setCreateModalVisible(true);
  };

  const onHideSecretRevealModal = () => {
    setSecretVisible(false);
    setClientId(null);
    setClientSecret(null);
    refetch();
  };
  return (
    <Box data-testid="api-key-manager" height="100%" style={{ height: "100%" }}>
      <Flex justifyContent="right">
        <Button mb="s" iconLeft onClick={handleOnButtonClick}>
          <Icon icon={["fas", "plus"]} />
          Create API Key
        </Button>
      </Flex>

      <FancyCard height="100%">
        <FancyCardBody>
          <Table
            data={apiKeys}
            columns={columns}
            enableTopToolbar={false}
            enablePagination={false}
            layoutMode="grid"
            enableExpandAll={false}
            enableColumnPinning={true}
            initialState={{
              columnVisibility: {
                "mrt-row-expand": false,
              },
              columnPinning: { right: ["actions"] },
            }}
          />
        </FancyCardBody>
      </FancyCard>
      <CreateModal
        visible={createModalVisible}
        onHideModal={() => {
          setCreateModalVisible(false);
        }}
        onCreateCredentials={(result) => {
          setClientId(result.clientId);
          setClientSecret(result.clientSecret);
          setSecretVisible(true);
          setCreateModalVisible(false);
        }}
      />
      <SecretRevealModal
        visible={secretVisible}
        clientId={clientId}
        clientSecret={clientSecret}
        onHideModal={() => {
          onHideSecretRevealModal();
        }}
      />
      <RotateSecretModal
        visible={rotateSecretVisible}
        clientId={clientId}
        onHideModal={() => {
          setRotateSecretVisible(false);
        }}
        onRotateSecret={(result) => {
          setClientId(result.clientId);
          setClientSecret(result.clientSecret);
          setSecretVisible(true);
          setRotateSecretVisible(false);
        }}
      />
      <DeleteSecretModal
        visible={deleteSecretVisible}
        clientId={clientId}
        onHideModal={() => {
          setDeleteSecretVisible(false);
        }}
        refetch={refetch}
      />
    </Box>
  );
};

APIKeyManager.propTypes = {};

export default APIKeyManager;
